// Because of the way this file is set up, this works the same
// as a document.ready statement.
// Add your code, either within the misc: section, or create your own function
// if you create your own, make sure to add a line at the bottom to run that code
// ie: Engine.ui.misc();
$(function() {
    "use strict";
    var Engine = {
        ui: {
            misc: function() {
              /*$(document).on('click','.second-level-trigger',function(event){
                event.preventDefault();
                var title = $(this).data('title');
                $(this).parents('.second-list').addClass('active');
                $(this).parents('.second-list').siblings().removeClass('active');
                $('.third-megalevel').each(function(){
                  var displayTitle = $(this).find('.trigger-title').data('title');
                  if(displayTitle == title){
                    $(this).parent().find('.third-megalevel').removeClass('active');
                    $(this).addClass('active');
                  }else{
                    //$(this).removeClass('active');
                  }
                });
              });*/
              $(document).on('mouseover','.second-level-trigger',function(event){
                //event.preventDefault();
                var title = $(this).data('title');
                $(this).parents('.second-list').addClass('active');
                $(this).parents('.second-list').siblings().removeClass('active');
                $('.third-megalevel').each(function(){
                  var displayTitle = $(this).find('.trigger-title').data('title');
                  if(displayTitle == title){
                    $(this).parent().find('.third-megalevel').removeClass('active');
                    $(this).addClass('active');
                  }else{
                    //$(this).removeClass('active');
                  }
                });
              });
              $(document).on('click', '.pro-badges .nav-pills a.active', function() { 
                var href = $(this).attr('href').substring(1); 
                //alert(href); 
                $(this).removeClass('active'); 
                $('.pro-badges .tab-pane[id="' + href + '"]').removeClass('active show'); 				
              }); 
              $('.wc_badges_cls li a').on('click',function(e){
                var position = $(this).position().left;
                //console.log(position);
                $('.des_bag_arrow').css('left',position+'px');
              });
              $(document).mouseup(function(e) { 
                var container = $(".pro-badges .tab-panes"); // target ID or class 
                // if the target of the click isn't the container nor a descendant of the container 
                if (!container.is(e.target) && container.has(e.target).length === 0) { 
                  // get Event here 
                  $('.pro-badges .active').removeClass('active show'); 
                } 
              });               
              $(document).on('click','.third-level .dropdown-link-first',function(event){
                event.preventDefault();
                $(this).parent('li').toggleClass('active-nav').siblings().removeClass('active-nav');
              });
              $('.third-level .dropdown-link-first').click(function() {
                $(this).parent('li').toggleClass('active-nav').siblings().removeClass('active-nav');
              });   
              $(document).on('click','.category_filter li .nav-link',function(ev){
                $(this).parents('.category_filter').find('ul.collection_slider').slick('refresh');
              });                             
              
              /*$(document).on('mouseenter', '.collection-template .pro-badges [data-toggle="tab"]', function () {
                $(this).tab('show');
              });*/
              
              /*$(document).on('mouseleave', '.collection-template .pro-badges [data-toggle="tab"]', function () {
                $('.tab-pane').removeClass('active show');
                $('.nav-pills li a').removeClass('active show');
              });*/
              
              $( ".grid-product__colors a" ).hover(function() {
                var variant_img = $(this).attr('data-variant-image');
                var variant_id = $(this).attr('data-variant-id');
                var variant_price = $(this).attr('data-variant-price');
                var variant_compare = $(this).attr('data-variant-compare');
                var variant_savings = $(this).attr('data-variant-saving');
                $(this).parents('.product_list-full').find('.pro_variant_img').attr('src',variant_img);
                $(this).parents('.product_list-full').find('.variant_id_form').attr('value',variant_id);
                $(this).parents('.product_list-full').find('.wc_price_val').html(variant_price);
                $(this).parents('.product_list-full').find('.wc_price_compare').html(variant_compare);
                $(this).parents('.product_list-full').find('.wc_price_save').html(variant_savings);
              });
              
              $('.plus').on('click', function () {
                var $qty = $(this).parents('.cart_qty').find(".QuantityBox .QuantityInput");
                var currentVal = parseInt($qty.val(), 10);
                if (!isNaN(currentVal)) {
                  $qty.val(currentVal+1);
                }
              });
              $('.product-template .minus').on('click', function () {
                var $qty = $(this).parents('.cart_qty').find(".QuantityBox .QuantityInput");
                var currentVal = parseInt($qty.val(), 10);
                if (!isNaN(currentVal) && currentVal > 1) {
                  $qty.val(currentVal - 1);
                }
              });
              $('.cart-page .minus').on('click', function () {
                var $qty = $(this).parents('.cart_qty').find(".QuantityBox .QuantityInput");
                var currentVal = parseInt($qty.val(), 10);
                if (!isNaN(currentVal) && currentVal > 0) {
                  $qty.val(currentVal - 1);
                }
              });
              
              $('.videomodal,.extra-popup').on('shown.bs.modal', function (e) {
               	var iframe_src = $(this).find('iframe').attr('src');
                if(iframe_src != '' && iframe_src != null && iframe_src != undefined){
                  iframe_src = iframe_src.replace("autoplay=0", "autoplay=1");
                  $(this).find('iframe').attr('src', iframe_src);
                }
              });
              $('.videomodal,.extra-popup').on('hide.bs.modal', function (e) {
               	//console.log('pause');
                var iframe_src = $(this).find('iframe').attr('src');
                if(iframe_src != '' && iframe_src != null && iframe_src != undefined){
                  iframe_src = iframe_src.replace("autoplay=1", "autoplay=0");
                  $(this).find('iframe').attr('src', iframe_src);
                }
              });
              
              $('.pro_cls_badges li a').on('click', function (e) {
                e.preventDefault();
                $(this).next('.tab-panes').parent().addClass('active');
                $(this).parent('li').siblings().removeClass('active');
                $(this).parents('.product_list-full').siblings().find('.pro_cls_badges li').removeClass('active');
              });     
              $(document).click(function(event){
                if (!($(event.target).closest(".pro_cls_badges li").length)) {
                  $('.pro_cls_badges li').removeClass('active');
                }
              });                           
              $('.wc-star-clickable').click(function(e){
              	e.preventDefault();
                $('html, body').animate({
                  scrollTop: $(".yotpo-no-reviews").offset().top
                }, 1000)
              });            
              $('.CartItem .plus,.CartItem .minus').on('click', function () {
                $('.update_cart').trigger('click');
              });
              if ( $('.p_img_content').children().length < 1 ) {
                $('.p_img_content').remove();
              }
              if ( $('.pro_most_popular .row').children().length < 1 ) {
                $('.pro_most_popular').remove();
              }
              if ( $('.upgrade_list').children().length < 1 ) {
                $('.upgrade_list').parent('.free_upgrade').remove();
              }
               if ( $('.p_badges_large .nav-pills').children().length < 1 ) {
                $('.p_badges_large ').remove();
              }
              if ( $('.recommand_slider li').children().length < 1 ) {
                $('.recommnd_pro').remove();
              }    
              if ( $('.extra_row_installation').children().length < 1 ) {
                $('.product_extra').remove();
              }    
              if($('.master_type_all .row').children().length < 1 ){
              	$('.master_type_all').remove();
              }
              if($('.bimini_cls_full .row').children().length < 1 ){
              	$('.bimini_cls_full').remove();
              }
              $(window).scroll(function() {
                if ($(this).scrollTop() > 2){  
                  $('.site-header_cls').addClass('sticky-header');
                }
                else{
                  $('.site-header_cls').removeClass('sticky-header');
                }
              });
              $('.arrow-right').on('click', function () {
              	$(this).next().slideToggle();
                $(this).toggleClass('active-nav');
              });
              $('.ftr_arrow').on('click', function () {
              	$(this).parent().next().slideToggle();
                $(this).parent().toggleClass('active-footer');
              });
              
              $("#nav-icon,.nav-close").on('click', function() {
                $("body").toggleClass("navopen");
                //$(this).toggleClass('open');
                return false;
              });
              var sidenavconatiner = $(".nav-side-panel");
              $(document).on('click', '.navopen', function(e){  
                if(!sidenavconatiner.is(e.target) && sidenavconatiner.has(e.target).length === 0)
                {
                  $('body').removeClass('navopen');  
                  $('#nav-icon').removeClass('open');
                }                
              });

              $('.coll-tab_inr').matchHeight({property: 'height'});
              $('.insta_inr').matchHeight({property: 'height'});
              $('.product_grid_iner').matchHeight({property: 'height'});
              $('.product_grid_iner figure').matchHeight({property: 'height'});
              //$('.product_grid_iner h5').matchHeight({property: 'height'});
              $('.type_cls_box').matchHeight({property: 'height'});
              $('.popular_list figure').matchHeight({property: 'height'}); 
              $('.news_btm_box li').matchHeight({property: 'height'}); 
              
            }, // end misc
            stickyHeader: function() {
                /*var HHeight = $('header').innerHeight();
                $('.app-inner-container').css("padding-top", HHeight + "px");
                $(window).scroll(function() {
                    if ($('.app-container').hasClass('app-inner-container')) {
                        var stickyScrollHeight = HHeight;
                    } else {
                        var stickyScrollHeight = 50;
                    }
                    if ($(this).scrollTop() >= stickyScrollHeight) {
                        $('.stickywrap').addClass('stickyHeader');
                    } else {
                        $('.stickywrap').removeClass('stickyHeader');
                    }
                });*/
            },
        }, // end ui
        utils: {
            sliders: function() {
			 /* category Filter */
              $('.collection_slider').slick({
                arrows: false,infinite: false,speed: 1000,slide: 'li',slidesToShow: 4,slidesToScroll: 4,adaptiveHeight: false,autoplay: false,lazyLoad: 'ondemand',dots: true,
                responsive: [
                  {
                    breakpoint: 1199,settings: {slidesToShow: 3,slidesToScroll: 3}
                  },
                  {
                    breakpoint: 700,settings: {slidesToShow: 2,slidesToScroll: 2}
                  },
                  {
                    breakpoint: 576,settings: {slidesToShow: 1,slidesToScroll: 1}
                  }
                ]
              });
              /* Logo Listr */
              $('.logo-bar').slick({
                arrows: false,infinite: false,speed: 900,slide: 'li',slidesToShow: 9,slidesToScroll: 9,adaptiveHeight: false,autoplay: false,lazyLoad: 'ondemand',dots: true,
                responsive: [
                  {
                    breakpoint: 992,settings: {slidesToShow: 6,slidesToScroll: 6}
                  },
                  {
                    breakpoint: 700,settings: {slidesToShow: 5,slidesToScroll: 5}
                  },
                  {
                    breakpoint: 576,settings: {slidesToShow: 3,slidesToScroll: 3}
                  },
                  {
                    breakpoint: 375,settings: {slidesToShow: 2,slidesToScroll: 2}
                  } 
                ]
              });
              /* Customer-Review */
              $('.insta_wrap').slick({
                arrows: false,infinite: false,speed: 900,slide: '.insta_list',slidesToShow:5,slidesToScroll: 5,adaptiveHeight: false,autoplay: false,lazyLoad: 'ondemand',dots: true,
                responsive: [
                  {
                    breakpoint: 1199,settings: {slidesToShow: 4,slidesToScroll: 4,}
                  },
                  {
                    breakpoint: 992,settings: {slidesToShow: 3,slidesToScroll: 3,}
                  },
                  {
                    breakpoint: 768,settings: {slidesToShow: 1,slidesToScroll: 1,}
                  } 
                ]
              });
              /* Laning Page */
              $('.landing_slider').slick({arrows: false,infinite: false,speed: 900,slide: 'li',slidesToShow:1,slidesToScroll: 1,adaptiveHeight: true,autoplay: false,lazyLoad: 'ondemand',dots: true});    
              
              jQuery('.icon-play-ytb').on('click', function() {
                $('.slick_video_list').removeClass('video-active');
                $(this).parent('.slick_video_list').addClass('video-active')
                var iframe_obj = $('.slick-current').find('iframe');
                var url = iframe_obj.attr('src');
                iframe_obj.attr('src', url + "?autoplay=1");
              });
              function stop_youtube_video(element){
                var iframe_src = element.find('iframe').attr('src');
                if(iframe_src != '' && iframe_src != null && iframe_src != undefined){
                  iframe_src = iframe_src.replace("autoplay=1", "autoplay=0");
                  element.find('iframe').attr('src', iframe_src);
                }
              }
              
              $('.landing_slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var play_video_this = $('.landing_slider .slick-slide[data-slick-index="'+currentSlide+'"]');
                stop_youtube_video(play_video_this);
              });              
              
              $('.landing_slider').on('afterChange', function(event, slick, currentSlide){
                $('.slick_video_list').removeClass('video-active');
                $( ".landing_slider li" ).each(function( index ){
                  if($(this).hasClass('slick-current')){
                    if($(this).hasClass('slick_video_list')){        
                      var activeSlide = $(this).find('iframe').attr('src');  
                      if(activeSlide != '' && activeSlide != null && activeSlide != undefined){
                        //var src = activeSlide.replace("autoplay=0", "autoplay=1");
                        //activeSlide.attr('src', src );
                      }
                    }
                  }
                });
              });
              
              
              /* REcommadtion Slider */
              $('.recommand_slider').slick({
                arrows: false,infinite: false,speed: 900,slide: 'li',slidesToShow:2,slidesToScroll: 2,adaptiveHeight: false,autoplay: false,lazyLoad: 'ondemand',dots: true,
                responsive: [
                  {
                    breakpoint: 640,
                    settings: {slidesToShow: 1,slidesToScroll: 1}
                  } 
                ]
              });              
              // product slider
              $('.shop_slider').slick({slidesToShow: 1,slidesToScroll: 1,arrows: false,fade: true,infinite:false,asNavFor: '.shop_thumb',adaptiveHeight: true,
                responsive: [
                  {
                     breakpoint:992,
                    settings: {dots:false,adaptiveHeight: true,arrows:true}
                  }
                 ]                     
              });
              $('.shop_thumb').slick({slidesToShow: 7,slidesToScroll: 1,asNavFor: '.shop_slider',dots: false,arrows: true,infinite:false,focusOnSelect: true,
              	responsive: [
                  {
                    breakpoint:1280,
                    settings: {slidesToShow: 5,slidesToScroll: 1}
                  }
                ]                       
              });
              
            },
        }, // end utils
    };
    Engine.ui.misc();
    Engine.ui.stickyHeader();
    Engine.utils.sliders();
  
  var sliceLength = $(".all_type_model_col").length - 6;
  if($(".all_type_model_col").length < 7){
    $(".all-type-btn").fadeOut('slow');
  }
    $(".all_type_model_col").slice(0, 6).show();
    $(".all-type-btn").on('click', function (e) {
      e.preventDefault();
      $(".all_type_model_col:hidden").slice(0, sliceLength).slideDown();
      if ($(".all_type_model_col:hidden").length == 0) {
        $(".all-type-btn").fadeOut('slow');
      }
      /*$('html,body').animate({
        scrollTop: $(this).offset().top
      }, 1500);*/
    });

});



// Remove focus outlines
$(".cart-page a,.cart-page button").on("touchstart", function(e) {
  setTimeout(function() {
    $(this).blur();
  }, 800);
});


// jQuery(document).ready(($) => {
//   $('.quantity').on('click', '.plus', function(e) {
//     let $input = $(this).prev('input.qty');
//     let val = parseInt($input.val());
//     $input.val( val+1 ).change();
//   });

//   $('.quantity').on('click', '.minus', 
//                     function(e) {

//     let $input = $(this).next('input.qty');

//     var val = parseInt($input.val());
//     if (val > 0) {
//       $input.val( val-1 ).change();
//     }
//   });


   

